<template>
  <div class="center">
    <div class="crumbs">
      <div class="box">
        <span class="position">выбранное место：</span>
        <span class="position p1">Главная/{{ title }}</span>
        <div class="dingwei">
          <div class="order o_1" @click="switching(1)">
            <span>Цена</span>
            <div class="up" :style="priceSorting == 1 ? 'border-bottom:5px solid #edc18a;' : 'border-bottom:5px solid #cecece;'"></div>
            <div class="down" :style="priceSorting == 2 ? 'border-top:5px solid #edc18a;' : 'border-top:5px solid #cecece;'"></div>
          </div>
          <div class="order" @click="switching(2)">
            <span>Время</span>
            <div class="up" :style="timeSort == 1 ? 'border-bottom:5px solid #edc18a;' : 'border-bottom:5px solid #cecece;'"></div>
            <div class="down" :style="timeSort == 2 ? 'border-top:5px solid #edc18a;' : 'border-top:5px solid #cecece;'"></div>
          </div>
          <img class="switch" :class="largePicture ? 'switch-rotate' : 'switch'" src="../assets/images/qiehuandatu.png" alt="" @click="switchImg" />

          <span v-if="propertyList.length != 0" class="attributes" @click="bubbleFrame = !bubbleFrame" ref="attributess" @mouseleave="moveOut" :style="attribute.length > 0 ? 'color:#edc18a' : ''">Фильтры</span>
        </div>
        <div class="pagination">
          <span class="jump"> До：</span>
          <el-select v-model="currentPage">
            <el-option v-for="item in pagination" :key="item" :value="item" @click.native="jumpPaging(item)" :disabled="pagination == 1"> </el-option>
          </el-select>
          <van-pagination v-model="currentPage" :total-items="totalNumber" :show-page-size="5" :items-per-page="24">
            <template #prev-text>
              <van-icon name="arrow-left" />
            </template>
            <template #next-text>
              <van-icon name="arrow" />
            </template>
          </van-pagination>
        </div>
      </div>
    </div>
    <!-- -->
    <div v-if="bubbleFrame" class="bubbleFrame" @mouseleave="bubbleFrame = !bubbleFrame" @blur="bubbleFrame = false" @mouseover="moveInto">
      <div class="category" v-for="(item, index) in propertyList" :key="index">
        <p class="title">{{ item.cname }}</p>
        <span class="active" v-for="(items, indexs) in item.option" :class="items.status == 1 ? 'attributes' : ''" :key="indexs" @click="selectAttribute(items)">{{ items.option }}</span>
      </div>
      <p class="button"><span class="cancel" @click="cancel">Нет</span><span class="determine" @click="determine">Да</span></p>
    </div>
  </div>
</template>

<script>
import { Pagination, Icon } from 'vant';
import 'vant/lib/pagination/style';
import 'vant/lib/icon/style';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { [Pagination.name]: Pagination, [Icon.name]: Icon },
  data() {
    //数据
    return {
      priceSorting: null, //价格排序
      timeSort: 2, //时间排序
      currentPage: 1, //当前分页
      onePageDisplay: 24, //每页展示的条数
      disable: false, //禁止选择跳转分页
      bubbleFrame: false, //气泡弹出框
      largePicture: false,
      propertyList: [], //属性列表
      attribute: [], //属性
      timer: null, //定时器
    };
  },
  props: {
    title: {
      type: String,
    },
    totalNumber: {
      type: Number,
    },
  },
  //计算属性
  computed: {
    pagination() {
      this.currentPage = 1; //切换分类切换当前分页
      // console.log(9999999);
      return parseInt(this.totalNumber % this.onePageDisplay == 0 ? this.totalNumber / this.onePageDisplay : this.totalNumber / this.onePageDisplay + 1);
    },
  },
  //监控data中的数据变化
  watch: {
    currentPage(val) {
      // console.log(val);
      this.$parent.ItemList(val);
      this.$forceUpdate();
    },
    bubbleFrame(val) {
      // if (val) {
      //   this.attribute = [];
      //   this.propertyList.forEach((item) => {
      //     item.option.forEach((items) => {
      //       items.status = 0;
      //     });
      //   });
      //   this.$parent.determine(this.attribute);
      //   this.$parent.ItemList(1);
      // }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {
    //属性列表移入事件
    moveInto() {
      clearTimeout(this.timer);
    },
    //属性按钮移出事件
    moveOut() {
      this.timer = setTimeout(() => {
        this.bubbleFrame = false;
      }, 400);
    },
    //属性列表-确定按钮
    determine() {
      this.currentPage = 1;
      this.bubbleFrame = false;
      this.$parent.determine(this.attribute);
    },
    //属性列表-取消按钮
    cancel() {
      this.currentPage = 1;
      this.propertyList.forEach((item) => {
        item.option.forEach((items) => {
          items.status = 0;
        });
      });
      this.attribute = [];
      setTimeout(() => {
        this.$parent.determine(this.attribute);
        this.bubbleFrame = false;
      }, 100);
      this.$forceUpdate();
    },
    //属性状态
    selectAttribute(item) {
      // this.propertyList[i].option[j].status = 1;
      // console.log(item);
      if (item.status == 0) {
        this.attribute.push(item.code);
        this.currentPage = 1;
        item.status = 1;
      } else {
        item.status = 0;
        this.attribute.forEach((code, i) => {
          if (code == item.code) {
            this.attribute.splice(i, 1);
          }
        });
        this.$forceUpdate();
      }
      this.$parent.determine(this.attribute);
      // console.log(this.attribute);
    },
    //获取属性列表
    getAttribute(cat_id, type) {
      this.attribute = [];
      // console.log(cat_id);
      let data = {
        token: localStorage.getItem('token'),
        cat_id,
        type,
      };
      this.api.getAttribute(data).then((res) => {
        // console.log(res);
        this.propertyList = res.data;
        this.propertyList.forEach((item) => {
          item.option.forEach((items) => {
            items.status = 0;
          });
        });
        // console.log(this.propertyList);
        this.$forceUpdate;
      });
    },
    attributes() {
      // let sh = this.$refs.attributess.getBoundingClientRect().top;
      // let h = this.$refs.attributess.offsetHeight;
      // console.log(h);
    },
    //切换大图
    switchImg() {
      this.$parent.setLargePicture(this.largePicture);
      this.largePicture = !this.largePicture;
    },
    switching(i) {
      if (i == 1) {
        this.timeSort = null;
        if (this.priceSorting == 1) {
          this.priceSorting = 2;
        } else {
          this.priceSorting = 1;
        }
        this.$parent.priceSorting(1, this.priceSorting);
      } else {
        this.priceSorting = null;
        if (this.timeSort == 1) {
          this.timeSort = 2;
        } else {
          this.timeSort = 1;
        }
        this.$parent.priceSorting(2, this.timeSort);
        // this.$parent.timeSorting(this.timeSort);
      }
      this.currentPage = 1;
    },
    //跳转分页
    jumpPaging(index) {
      this.currentPage = index;
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.attributes();
  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
// @import url( vant/lib/pagination/index.css );; //@import url();
/deep/.el-popover--plain {
  width: 109px !important;
  height: 350px !important;
  background: #ffffff !important;
  border: 1px solid #edc18a !important;
  opacity: 1;
}
/deep/ .el-input__inner:focus {
  border-color: #edc18a !important;
}
/deep/.el-select-dropdown__item,
.selected {
  color: #edc18a !important;
}
/deep/.van-pagination__item--active {
  background: #edc18a;
  color: #ffffff !important;
  opacity: 1;
  border-radius: 2px;
}
/deep/.van-pagination__item:active {
  background: #edc18a !important;
  color: #ffffff !important;
}

/deep/.van-pagination {
  height: 30px;
  margin: 4px;
  .van-pagination__item {
    height: 100%;
    width: 30px !important;
    color: #e9ad61;
    min-width: 30px;
    margin-right: 6px;
    border-radius: 2px;
  }
}
/deep/.van-icon-arrow-left,
/deep/ .van-icon-arrow {
  color: #666666;
}
/deep/.van-pagination__item--disabled {
  display: none !important;
}
.center {
  height: 38px;
  .crumbs {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 38px;
    background: #fff7ec;
    opacity: 1;
    left: 0;
    .box {
      width: 1200px;
      margin: 0 auto;
      height: 100%;
      position: relative;
      .position {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 38px;
        color: #e9ad61;
        opacity: 1;
      }
      .position:focus {
        color: #000;
      }
      .p1 {
        margin-right: 73px;
      }
      .o_1 {
        margin-right: 20px;
      }
      .dingwei {
        display: inline-block;
        position: absolute;
        left: 350px;
      }
      .order {
        display: inline-block;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #666666;
        opacity: 1;
        position: relative;
        width: 52px;
        cursor: pointer;
        span {
          margin-right: 6px;
        }
        .up {
          display: inline-block;
          width: 0;
          top: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-bottom: 5px solid #edc18a;
          position: absolute;
          top: 14px;
        }
        .down {
          display: inline-block;
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 5px solid #cecece;
          position: absolute;
          bottom: 12px;
        }
      }
      .switch {
        display: inline-block;
        width: 24px;
        height: 24px;
        top: 7px;
        bottom: 0px;
        position: relative;
        transform: rotate(0deg);
        transition: transform 0.2s;
        margin: 0px 37px;
      }
      .switch-rotate {
        transform: rotate(180deg);
        transition: transform 0.2s;
      }

      .attributes {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 38px;
        color: #666666;
        cursor: pointer;
        opacity: 1;
        position: relative;
      }
      .pagination {
        display: inline-block;
        position: absolute;
        height: 100%;
        right: 0;
        .jump {
          float: left;
          width: 42px;
          height: 19px;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 38px;
          color: #333333;
          opacity: 1;
        }
        /deep/.van-pagination {
          display: -webkit-inline-box;
          position: relative;
        }
        /deep/.el-select {
          margin: 4px 0;
          width: 80px;
          float: left;
          height: 30px;
          .el-input {
            height: 100%;
          }
          .el-input__inner {
            width: 100%;
            height: 100%;
          }
          .el-select__caret {
            line-height: 30px;
          }
        }
        .van-pagination {
          margin: 4px 0;
          margin-left: 20px;
        }
      }
    }
  }
  .bubbleFrame {
    z-index: 9999999999999;
    width: 809px;
    border: 1px solid #edc18a;
    position: relative;
    left: 250px;
    top: 50px;
    // z-index: 2;
    background: #ffffff;
    padding: 16px 16px 14px 16px;
    display: inline-block;
    .category {
      margin-bottom: 30px;
      .title {
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 19px;
        color: #333333;
        opacity: 1;
        margin-bottom: 12px;
      }
      .attributes {
        background: #fcf8f4 !important;
        border: 1px solid #edc18a !important;
        color: #e9ad61 !important;
      }
      .active {
        display: inline-block;
        width: 90px;
        height: 24px;
        background: #f8f8f8;
        border: none;
        opacity: 1;
        border-radius: 2px;
        border: 1px solid #f8f8f8;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        line-height: 24px;
        color: #666666;
        opacity: 1;
        margin-right: 25px;
        cursor: pointer;
      }
    }
    .button {
      text-align: right;
      .cancel {
        display: inline-block;
        text-align: center;
        width: 90px;
        height: 24px;
        background: #ffffff;
        border: 1px solid #e6e6e6;
        opacity: 1;
        border-radius: 2px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        margin-right: 13px;
        cursor: pointer;
      }
      .determine {
        display: inline-block;
        cursor: pointer;
        text-align: center;
        width: 90px;
        height: 24px;
        background: #edc18a;
        border: 1px solid #e6e6e6;
        opacity: 1;
        border-radius: 2px;
        line-height: 24px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
      }
    }
  }
  .bubbleFrame::before {
    content: '';
    width: 0;
    height: 0;
    border: 10px solid;
    position: absolute;
    top: -20px;
    left: 340px;
    border-color: transparent transparent #edc18a transparent;
  }
  .bubbleFrame::after {
    content: '';
    width: 0;
    height: 0;
    border: 10px solid;
    position: absolute;
    top: -19px;
    left: 340px;
    border-color: transparent transparent #fff transparent;
  }
}
</style>
